import React from 'react';
import { ContentBox } from 'components/content-box';

export function Error404Box({ children }) {
  return (
    <ContentBox>
      <div data-e2e="ct-error-404" className="ct-error-404">
        <div className="row">
          <div className="col">{children}</div>
          <div className="col image">
            <img src={`${window.__MOVINGIMAGE_CT_PUBLIC_URL}/static/img/tv-404.png`} alt="Error 404" />
          </div>
        </div>
      </div>
    </ContentBox>
  );
}
